import { jsx, jsxs } from "react/jsx-runtime";
import { Slider, Stack, Typography } from "@mui/material";
import { formatRemValue, parseNumericPixelValue } from "../utils/fontSize.js";
function FontSizeInput(props) {
  const { value, onChange, title, htmlFontSize } = props;
  const numericPixelValue = parseNumericPixelValue(value, htmlFontSize);
  const displayValue = formatRemValue(numericPixelValue, htmlFontSize);
  return /* @__PURE__ */ jsxs(Stack, { flex: "1 1 auto", children: [
    /* @__PURE__ */ jsx(Stack, { alignItems: "center", direction: "row", justifyContent: "spaceBetween", children: /* @__PURE__ */ jsxs(
      Typography,
      {
        sx: (theme) => ({
          color: theme.vars.palette.text.secondary,
          display: "flex",
          flex: "1 1 auto",
          fontSize: 16
        }),
        children: [
          title,
          ":",
          /* @__PURE__ */ jsx("span", { style: { flex: "1 1 auto", paddingLeft: 4 }, children: displayValue }),
          /* @__PURE__ */ jsxs(
            Typography,
            {
              sx: (theme) => ({
                color: theme.vars.palette.text.primary,
                opacity: 0.3
              }),
              children: [
                "(",
                numericPixelValue,
                "px)"
              ]
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ jsx(
      Slider,
      {
        max: 96,
        min: 6,
        onChange: (_, v) => {
          const value2 = Array.isArray(v) ? v[0] : v;
          onChange(formatRemValue(value2, htmlFontSize));
        },
        size: "small",
        value: numericPixelValue
      }
    )
  ] });
}
export {
  FontSizeInput
};
//# sourceMappingURL=FontSizeInput.js.map
